import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { useTranslation } from "react-i18next";
import { MarketingLayout, I18nPageHero } from "@/components/marketing/Layout";

export const Route = createFileRoute("/changelog")({
 head: () => {
 const seo = buildSeo({
 path: "/changelog",
 title: "Changelog — Reality Twin Network releases, week by week",
 description: "The honest release history of Reality Twin — currently publicly available. Built by Ruznic Marketing in Hinwil.",
 type: "article",
 });
 return {
...seo,
 scripts: [
 {
 type: "application/ld+json",
 children: JSON.stringify({
 "@context": "https://schema.org",
 "@type": "Blog",
 name: "Reality Twin Changelog",
 description: "Weekly release notes for the Reality Twin Network platform.",
 url: "https://realitytwin.io/changelog",
 publisher: { "@type": "Organization", name: "Ruznic Marketing" },
 inLanguage: "en",
 }),
 },
 ],
 };
 },
 component: ChangelogPage,
});

function ChangelogPage() {
 const { t } = useTranslation();
 const entries = t("routes.changelog.entries", { returnObjects: true }) as { date: string; version: string; title: string; highlights: string[]; body: string }[];
 return (
 <MarketingLayout>
 <I18nPageHero tKey="pages.changelog" />
 <section className="py-20">
 <div className="mx-auto max-w-3xl px-6 space-y-16">
 {entries.map((e) => (
 <article key={e.version} className="grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-6 sm:gap-10">
 <aside>
 <div className="font-mono-eyebrow">{e.version}</div>
 <div className="mt-2 text-[13px] text-muted-foreground">{e.date}</div>
 </aside>
 <div>
 <div className="flex items-center gap-2 mb-3">
 {e.highlights.map((h) => (
 <span key={h} className="rounded-full hairline bg-cream px-2 py-0.5 text-[11px] font-medium text-muted-foreground">{h}</span>
 ))}
 </div>
 <h2 className="font-serif text-[28px] leading-tight tracking-[-0.025em]">{e.title}</h2>
 <p className="mt-3 text-[15px] leading-[1.65] text-muted-foreground">{e.body}</p>
 </div>
 </article>
 ))}
 </div>
 </section>
 </MarketingLayout>
 );
}
